import accountApi from '@/services/api/accountApi';

const initialState = () => ({
  passwordChangeProgress: false,
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async passwordChange({ commit }, { userId, password }) {
      commit('setPasswordChangeProgress', true);
      try {
        const response = await accountApi.passwordChange({ userId, password });
        commit('notifications/addNotifySuccess', ['Пароль успешно изменен'], { root: true });
        return response.data;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка смены пароля'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setPasswordChangeProgress', false);
      }
    },
  },
  mutations: {
    setPasswordChangeProgress(state, bool) {
      state.passwordChangeProgress = bool;
    },
  },
  getters: {
    passwordChangeProgress: (state) => state.passwordChangeProgress,
  },
};
